<div class="max-w-md mx-auto p-4 bg-base-100 border border-base-300 rounded-md">
  <form [formGroup]="metadataTagForm" (ngSubmit)="submitForm()">
    <h2 class="text-lg font-semibold mb-4">Create Metadata Tag</h2>

    <div class="mb-4">
      <label class="block text-sm font-medium mb-1">Key</label>
      <input class="input input-bordered w-full" formControlName="key" placeholder="Enter key" />
    </div>

    <div class="mb-4">
      <label class="block text-sm font-medium mb-1">Value</label>
      <div class="flex gap-2 items-center">
        <input class="input input-bordered w-full" formControlName="value" placeholder="Enter value" />
        <button
          class="btn btn-sm btn-outline"
          type="button"
          (click)="addPair()"
          [disabled]="metadataTagForm.get('value')?.invalid"
        >
          Add
        </button>
      </div>
    </div>
    
    <div *ngIf="tagPairs.length" class="mb-4">
      <h4 class="text-sm font-semibold mb-2">Pending Tags</h4>
      <ul class="space-y-2">
        <li
          *ngFor="let pair of tagPairs; let i = index"
          class="flex justify-between items-center bg-base-200 rounded px-3 py-2"
        >
          <span>{{ pair.key }}: {{ pair.value }}</span>
          <button class="btn btn-xs btn-error" type="button" (click)="removePendingTag(i)">Remove</button>
        </li>
      </ul>
    </div>

    <button class="btn btn-primary w-full" type="submit" [disabled]="!tagPairs.length">Create Tag(s)</button>
  </form>
</div>

<div class="mt-6">
  <h3 class="text-sm font-semibold mb-2">Existing Metadata Tags</h3>

  <ul class="space-y-2">
    <li *ngFor="let key of objectKeys(groupedMetadataTags())">
      <div class="bg-base-200 rounded px-3 py-2">
        <ul class="space-y-1">
          <li *ngFor="let value of groupedMetadataTags()[key]; let i = index" class="flex justify-between items-center">
            <span class="w-1/3 font-medium" *ngIf="i === 0">{{ key }}</span>
            <span class="w-1/3" *ngIf="i !== 0"></span>
            <span class="w-2/3">{{ value }}</span>
            <button class="btn btn-xs btn-error" (click)="deleteTagByKeyValue(key, value)">Delete</button>
          </li>
        </ul>
      </div>
    </li>
  </ul>
</div>
